<template>
  <div class="lib__panel">
    <div class="lib__panel__main">
      <div class="lib__text-small lib__text-gray-500">{{ $t('resume.workAddress') }}</div>
      <span v-if="isConsumptionAddress">
        {{ address.streetName }} {{ address.houseNumber }} {{ address.complement || '' }} {{ address.complementBox || '' }}
        <br />
        {{ address.zipCode }} {{ address.cityName }}
      </span>
      <span v-else>
        <template v-if="!address.isMapLocation">{{ address.streetSubCity.name }} {{ address.houseNumber }}</template>
        <template v-else>{{ address.mapLocation.lat }} {{ address.mapLocation.lng }}</template>
        - {{ address.subCity.zipCode }} {{ address.subCity.cityName }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { AddressPoint, ConsumptionAddress } from '@/models'

@Component
export default class ResumeInfoItem extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: true }) public readonly address!: AddressPoint | ConsumptionAddress
  //#endregion

  //#region [Computed]
  public get isConsumptionAddress(): boolean {
    return (this.address as ConsumptionAddress).cityName !== undefined
  }
  //#endregion
}
</script>